module.exports = __webpack_public_path__ + "img/banner_l.2dc8540.png";